import axios from 'axios';

export default () => {
  const ax = axios.create({
    baseURL: '/api/',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });

  ax.interceptors.request.use(
    (reqConfig) => {
      reqConfig.headers.authorization = `Bearer ${localStorage.getItem('access_token')}`; // eslint-disable-line no-param-reassign
      return reqConfig;
    },
    (err) => Promise.reject(err),
  );

  return ax;
};
